import React from "react";

// const riskTypes = [
//   { label: "Low Risk", count: 12 },
//   { label: "High UPOBPAS", count: 8 },
//   { label: "High Nivesh Mitra", count: 5 },
//   { label: "PMAY", count: 9 },
//   { label: "Govt Building", count: 3 },
// ];

const RiskTypeBar = ({ selected, onSelect, riskCount, setRiskFilter }) => {
  console.log("fromBar", riskCount);
  const handleClick = (riskType) => {
    setRiskFilter(riskType);
  };
  return (
    <div className="risk-type-bar">
      {riskCount.map(({ action, count, riskType }) => (
        <button key={action} className={`risk-type-button ${selected === action ? "active" : ""}`} onClick={() => handleClick(riskType)}>
          {action} <span className="count">({count})</span>
        </button>
      ))}
    </div>
  );
};

export default RiskTypeBar;
